/* eslint-disable */
import MyMapsContextMenu from "~/es6/mymaps.contextmenu";
import { node } from "~/util/dom";
import { _ } from "~/i18n";

export default class PhotoContextMenu extends MyMapsContextMenu {

	/**
	 * Vytvoreni itemu a naplneni do pole.
	 */
	_createItem(name: string): HTMLLIElement {
		let el = node("li", { className: "contextmenu-item" });
		let title = node("h3", { className: "name", textContent: _("photoContextMenu." + name) });
		el.appendChild(title);

		return el;
	}
}
